<template>
  <body>
    <div class="main_wraper">
      <!-- <div class="side_navbar">
        <nav id="sidebar" class="active mobilealign">
          <div class="sidebar-header">
            <div class="menu_logos1 sidebarCollapse">
              <img src="images/logo-1.png" class="img-fluid">
              <h3>Blubirch <span>Creating Sutainable value</span></h3>
            </div>
          </div>
          <div class="menu_divide">
            <ul class="list-unstyled components">
              <li><a href="#"><img src="images/icons/service-ex-icon1a.png" class="img-fluid"><i class="menu_texts1">Dispatch</i></a></li>
              <li><a href="#"><img src="images/icons/service-ex-icon2.png" class="img-fluid"><i class="menu_texts1">Executive</i></a></li>
              <li><a href="#"><img src="images/icons/service-ex-icon3.png" class="img-fluid"><i class="menu_texts1">Executive</i></a></li>
              <li><a href="#"><img src="images/icons/service-ex-icon4.png" class="img-fluid"><i class="menu_texts1">Executive</i></a></li>
              <li><a href="#"><img src="images/icons/service-ex-icon5.png" class="img-fluid"><i class="menu_texts1">Executive</i></a></li>
              <li><a href="#"><img src="images/icons/service-ex-icon6.png" class="img-fluid"><i class="menu_texts1">Executive</i></a></li>
              <li><a href="#"><img src="images/icons/service-ex-icon7.png" class="img-fluid"><i class="menu_texts1">Executive</i></a></li>
              <li><a href="#"><img src="images/icons/service-ex-icon8.png" class="img-fluid"><i class="menu_texts1">Executive</i></a></li>
              <li><a href="#"><img src="images/icons/service-ex-icon9.png" class="img-fluid"><i class="menu_texts1">Executive</i></a></li>

            </ul>
          </div>
          <div class="head_profil">
            <div class="menu_profile"><img src="images/profile-img-1.jpg"></div>
            <h3>Ganesh S Shenoy <span>Test Executive</span></h3>
          </div>
        </nav>
      </div> -->
      <div class="mobile_head">
        <button class="menu_toggle sidebarCollapse">
          <i class="fa fa-bars"></i>
        </button>
        <h3 class="main_header">Customer Returns</h3>
      </div>
      <div class="rigt_navbar" id="content">
        <ul class="breadcrambs display_non">
          <li>Return Management</li>
          <li><i class="fa fa-chevron-right"></i></li>
          <li><a href="#">Service Executive</a></li>
        </ul>

        <h3 class="main_header display_non">Service Executive</h3>
        <div class="invoic_srch">
          <div class="invoic_srcw pdong_btm">
            <h3 class="sub_header1">Invoice Number</h3>
            <form>
              <div class="form_group1">
                <i class="fa fa-search" aria-hidden="true"></i>
                <input
                  class="search_form"
                  type="text"
                  placeholder="Scan or Enter the Invoice Number"
                />
              </div>
            </form>
            <button class="main_button">Search</button>
          </div>
        </div>
      </div>
    </div>
  </body>
</template>
